// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-actions-bottom-wraper {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  border-radius: 4px;
  z-index: 99;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-end;
  transition: 0.3s all ease-in-out;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: flex;
}
.chat-actions-bottom-wraper.close-bottom-slide {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.chat-actions-bottom-wraper.close-bottom-slide .actions-contnet-data {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.chat-actions-bottom-wraper .actions-contnet-data {
  max-height: 75%;
  width: 100%;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  background: var(--sdk-global-white-bg);
  border-radius: 4px 4px 0px 0px;
}
.chat-actions-bottom-wraper .actions-contnet-data.actions-contnet-full-height {
  max-height: 100%;
  height: 100%;
}
.chat-actions-bottom-wraper.chat-widget-overflow-wrapper {
  width: calc(100% - 72px) !important;
  top: 0 !important;
  left: 72px;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/actionsButtonSlider/actionsBottomSlider.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,8BAAA;EAEA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;AADJ;AAEI;EACI,+BAAA;EACA,uBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;AAAR;AACQ;EACI,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AACZ;AAEI;EACI,eAAA;EACA,WAAA;EACA,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;EACA,sCAAA;EACA,8BAAA;AAAR;AACQ;EACI,gBAAA;EACA,YAAA;AACZ;AAEI;EACI,mCAAA;EACA,iBAAA;EACA,UAAA;AAAR","sourcesContent":["\n.chat-actions-bottom-wraper{\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    background: rgba(0, 0, 0, 0.6);\n    // background: var(--sdk-gloabl-text-color);\n    backdrop-filter: blur(4px);\n    border-radius: 4px;\n    z-index: 99;\n    display: flex;\n    align-items: flex-end;\n    flex-direction: column;\n    justify-content: flex-end; \n    transition: 0.3s all ease-in-out;\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: 0.5s;\n    animation-duration: 0.5s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    display: flex;\n    &.close-bottom-slide{\n        -webkit-animation-name: fadeOut;\n        animation-name: fadeOut;\n        -webkit-animation-duration: 0.5s;\n        animation-duration: 0.5s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        .actions-contnet-data{\n            -webkit-animation-name: fadeInDown;\n            animation-name: fadeInDown;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n        }\n    }\n    .actions-contnet-data{\n        max-height: 75%;\n        width: 100%;\n        -webkit-animation-name: fadeInUp;\n        animation-name: fadeInUp;\n        -webkit-animation-duration: 0.5s;\n        animation-duration: 0.5s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        background: var(--sdk-global-white-bg);\n        border-radius: 4px 4px 0px 0px;\n        &.actions-contnet-full-height{\n            max-height: 100%;\n            height: 100%;\n        }\n    }\n    &.chat-widget-overflow-wrapper{\n        width: calc(100% - 72px) !important;\n        top: 0 !important;\n        left: 72px ;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
